<div class="noprint">

  <label class="d-flex justify-content-center mb-1">
    <h5>{{"statement-date-range"|translate}}</h5>
  </label>

  <!-- <h1 mat-dialog-title></h1> -->

  <div mat-dialog-content class="row">
    <div class="col-12 mb-2">
      <label style="float: right;">{{"date-from"|translate}}</label>

      <input (focus)="pickerFrom.open()" class="form-control" #date id="date" matInput name="depositDate" [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom">
      <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
      <mat-datepicker #pickerFrom></mat-datepicker>
    </div>
    <div class="col-12">
      <label style="float: right;">{{"date-to"|translate}}</label>

      <input (focus)="pickerTo.open()" class="form-control" #date id="date" matInput name="depositDate" [(ngModel)]="dateTo" [matDatepicker]="pickerTo">
      <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
      <mat-datepicker #pickerTo></mat-datepicker>
    </div>
  </div>
  <br>

  <button class="btn btn-primary" *ngIf="!statement" (click)="viewStatement()" cdkFocusInitial>
    <span *ngIf="loadingStatement" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{"send"|translate}}
  </button>
  <button class="btn btn-primary" *ngIf="statement" [useExistingCss]="true" printSectionId="print-statement" ngxPrint>{{"print"|translate}}</button>

</div>

<app-statement-details id="print-statement" [statement]="statement"></app-statement-details>
